import script from "./LessonPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./LessonPopup.vue?vue&type=script&setup=true&lang=ts"

import "./LessonPopup.vue?vue&type=style&index=0&id=64fdce34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64fdce34"]])

export default __exports__